<template>
    <div
        v-if="payNowPriceLocal"
        :class="{ 'selected': selected === true, 'seller': isUpsell, 'agent': !isUpsell }"
        :for="value"
        class="hslp-package d-block rounded float-none cursor-pointer font-size-5 h-100 m-0"
        @click="selectPackage"
    >
        <div v-if="!isUpsell">
            <b-form-row class="align-items-center">
                <b-col cols="8">
                    <h3 class="font-weight-normal">
                        <span class="text-capitalize">{{ getName() }}</span>

                        <b-badge
                            v-if="mostPopular"
                            class="text-white font-size-6 font-weight-bold ml-2"
                            pill
                            variant="primary"
                        >
                            <i class="fas fa-star w-auto"/> MOST POPULAR
                        </b-badge>

                        <b-badge
                            v-if="bestValue"
                            class="text-white font-size-6 font-weight-bold ml-2"
                            pill
                            variant="success"
                        >
                            <i class="fas fa-dollar-sign w-auto"/> BEST VALUE
                        </b-badge>
                    </h3>

                    <div>
                        Up to {{ legalHours | currency('$', 0) }} in legal representation. For claims made within
                        {{ yearsOfProtection }}
                        {{ yearsOfProtection > 1 ? 'years' : 'year' }} of closing.
                    </div>
                </b-col>

                <b-col class="ml-auto text-right">
                    <div class="font-size-2 font-weight-bold text-green">
                        $<input
                        :ref="getSnakeName('now')"
                        v-model="payNowPriceLocal"
                        :name="getSnakeName('now')"
                        class="defaultPrice text-green"
                        disabled="disabled"
                        type="text"
                    /> now
                    </div>
                    <div>
                        Or {{ payAtClosePriceLocal | currency('$', 0) }} at close of sale
                    </div>
                </b-col>
            </b-form-row>
        </div>
        <div v-else>
            <div>
                <div
                    :class="{'bg-primary text-white' : mostPopular, 'text-gray-dark': (lowestPrice || !mostPopular)}"
                    class="text-center h-25 w-100 d-inline-block"
                >
                    {{ lowestPrice ? 'Lowest price' : mostPopular ? 'Most popular' : '' }}
                </div>

                <div
                    class="text-left ml-4"
                >
                    <span v-if="selectedPaymentMethod === 'pay-now'">
                        Pay Now
                    </span>

                    <span v-else>
                        Pay at Close
                    </span>
                </div>

                <b-row align-h="center">
                    <b-col cols="8">
                        <b-img
                            :alt="iconAlt"
                            :src="iconSrc"
                            fluid
                        />
                    </b-col>
                </b-row>

                <h4 class="text-gray-dark text-center mb-0">
                    {{ getName().replace('Package', '') }}
                </h4>

                <div class="ml-4">
                    <p>Up to {{ legalHours | currency('$', 0) }} paid legal representation</p>

                    <p>Forms included</p>

                    <p>Protect yourself for up to 4 years after the sale - our legal experts have your back!</p>
                </div>

                <div class="ml-4">
                    <div v-if="selectedPaymentMethod === 'pay-now'">
                        <div class="text-dark">
                            <span class="text-decoration-line-through">
                                {{ payAtClosePriceLocal | currency('$', 0) }}
                            </span>
                            <span class="font-size-2 font-weight-bold">
                                {{ payNowPriceLocal | currency('$', 0) }}
                            </span>
                        </div>
                        <p>
                            Pay now and save <span>{{ (payAtClosePriceLocal - payNowPriceLocal) | currency('$', 0) }}</span>
                        </p>
                    </div>

                    <div v-else>
                        <div class="text-dark">
                            <span class="font-size-2 font-weight-bold">
                                {{ payAtClosePriceLocal | currency('$', 0) }}
                            </span>
                        </div>

                        <p>
                            Pay later out of sale proceeds.
                        </p>
                    </div>
                </div>

                <div class="mb-2">
                    <b-button
                        block
                        class="pt-2 protected-button"
                        size="sm"
                        variant="primary"
                        @click="handlePayment"
                    >
                        Get Protected
                    </b-button>
                </div>
            </div>
        </div>
        <input
            v-model="payNowPriceLocal"
            :name="getSnakeName('now')"
            class="testPrice"
            type="text"
            @change="changePackage"
        />
        <input
            v-model="payAtClosePriceLocal"
            :name="getSnakeName('pac')"
            class="testPrice"
            type="text"
            @change="changePackage"
        />
    </div>
</template>

<script>
import './HslpPackage.scss';
import {replaceAll} from "@helpers/string";

export default {
    name: 'HslpPackage',
    props: {
        value: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
        payNowPrice: {
            type: Number,
            default: 0,
        },
        payAtClosePrice: {
            type: Number,
            default: 0,
        },
        lowestPrice: {
            type: Boolean,
        },
        mostPopular: {
            type: Boolean,
        },
        bestValue: {
            type: Boolean,
        },
        legalHours: {
            type: Number,
        },
        yearsOfProtection: {
            type: Number,
        },
        isUpsell: {
            type: Boolean,
        },
        iconSrc: {
            type: String,
        },
        iconAlt: {
            type: String,
        },
        selectedPaymentMethod: {
            type: String,
        },
        package: {
            type: Object,
        }
    },
    data: function () {
        return {
            payNowPriceLocal: this.payNowPrice,
            payAtClosePriceLocal: this.payAtClosePrice,
        };
    },
    methods: {
        selectPackage() {
            this.$emit('click', this.package);
        },
        handlePayment() {
            this.$emit('select-payment-method', this.selectedPaymentMethod);
        },
        getName() {
            let result = this.name.indexOf("Year Protection Package");
            if (result !== -1) {
                return this.yearsOfProtection + ' Year Protection Package';
            }
            return this.name;
        },
        getSnakeName(text) {
            let name = replaceAll(this.getName().toLowerCase().replace(' protection package', ''),' ', '_');
            return text + '_' + name;
        },
        measureTextWidth(txt, font) {
            let element = document.createElement('canvas');
            let context = element.getContext("2d");
            context.font = font;
            return context.measureText(txt).width + 4;
        },
        calculatedWidth(inputElementRef) {
            this.$nextTick(() => {
                let inputElement = inputElementRef ? this.$refs[inputElementRef] : null;
                if (inputElement) {
                    let style = window.getComputedStyle(inputElement, null);
                    let text = inputElement.value || inputElement.placeholder;
                    inputElement.style.width = this.measureTextWidth(text, style.font) + 'px';
                }
            });
        },
        changePackage() {
            if (this.isUpsell) {
                this.package.pricePayNowSeller = this.payNowPriceLocal;
                this.package.pricePayAtCloseSeller = this.payAtClosePriceLocal;
            } else {
                this.package.pricePayNowAgent = this.payNowPriceLocal;
                this.package.pricePayAtCloseAgent = this.payAtClosePriceLocal;
            }
        },
    },
    watch: {
        payNowPriceLocal: function () {
            this.calculatedWidth(this.getSnakeName('now'));
            this.calculatedWidth(this.getSnakeName('pac'));
        }
    },
    mounted() {
        this.calculatedWidth(this.getSnakeName('now'));
        this.calculatedWidth(this.getSnakeName('pac'));
    }

}
</script>
